export function cancelGenerate(that) {
  that.name = ''
  that.num = that.centerData.map(item => {
    item.num = ''
    return item
  })
  that.createLoading = false
  that.section_length = null
  that.section_count = ''
  that.num = null
  that.count = {}
  that.generateDialogVisible = false
  that.readyOnly = false
  that.getList()
}
